import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {CountryState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class CountryQuery extends QueryEntity<CountryState> {

  constructor(protected store: Store) {
    super(store);
  }

}
